import React from "react";
import { Card } from "../ui/card";
import { Button } from "../ui/button";
import { CheckCircle2 } from "lucide-react";
import { Separator } from "../ui/separator";

const ConfirmationView = ({
  userData,
  isAdminMode,
  onReturnToAdmin,
  onExit,
  cessao,
}) => {
  const [timeoutStatus, setTimeoutStatus] = React.useState(3);

  // Formatter helper for Brazilian date format (DD/MM/YYYY)
  const formatter = (value) => {
    if (!value) return "";
    // Accept ISO dates like YYYY-MM-DD or full ISO timestamps
    const iso = String(value).slice(0, 10);
    if (/^\d{4}-\d{2}-\d{2}$/.test(iso)) {
      const [y, m, d] = iso.split("-");
      return `${d}/${m}/${y}`;
    }
    // Fallback to Date parsing and locale formatting
    const dObj = new Date(value);
    if (isNaN(dObj.getTime())) return value;
    return dObj.toLocaleDateString("pt-BR");
  };

  React.useEffect(() => {
    if (timeoutStatus === 0 && !cessao) {
      try {
        const phone = "11933333011";
        const whatsappNumber = `55${phone}`;
        const text = encodeURIComponent(
          `Olá quero saber sobre o processo 0012044-14.2017.5.18.0007 (STIUEG). Acabei de assinar o documento para receber em ${formatter(
            userData.dataPrimeiraParcela
          )} Nome: ${userData.nomeCompleto || ""} CPF: ${userData.cpf || ""}`
        );
        const url = `https://wa.me/${whatsappNumber}?text=${text}`;
        window.open(url);
      } catch (e) {
        // Silent catch or add proper logger
      }
    }

    if (timeoutStatus > 0) {
      const timer = setTimeout(() => {
        setTimeoutStatus(timeoutStatus - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [timeoutStatus, userData, cessao]);

  return (
    <div className="min-h-screen p-4 md:p-8 bg-slate-50 w-full flex items-center justify-center">
      <div className="max-w-2xl w-full gap-y-6 flex flex-col">
        {!cessao && (
          <Card className="p-8 shadow-sm border-2 border-yellow-100 bg-white/80 backdrop-blur-sm text-center w-full max-w-sm self-center">
            <p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mb-1">
              Redirecionamento em
            </p>
            <p className="text-3xl font-black text-slate-900 italic tracking-tighter">0:0{timeoutStatus}</p>
          </Card>
        )}

        <Card className="p-10 shadow-float border-0 bg-white backdrop-blur-sm text-center relative overflow-hidden">
          <div className="absolute top-0 inset-x-0 h-1 bg-gradient-to-r from-transparent via-yellow-400 to-transparent opacity-50" />

          <div className="mx-auto w-14 h-14 rounded-full bg-slate-50 flex items-center justify-center mb-6 border border-slate-100">
            <CheckCircle2 className="w-7 h-7 text-yellow-600" />
          </div>

          <h2 className="text-xl font-black text-slate-900 mb-4 tracking-tight uppercase">
            Contratos enviados!
          </h2>

          <div className="space-y-6">
            <div className="space-y-1">
              <p className="text-xs font-medium text-slate-400 uppercase tracking-wider">
                E-mail cadastrado
              </p>
              <p className="text-lg font-bold text-slate-900">{userData?.email}</p>
            </div>

            <div className="space-y-1">
              <p className="text-xs font-medium text-slate-400 uppercase tracking-wider">
                WhatsApp informado
              </p>
              <p className="text-lg font-bold text-slate-900">
                {userData?.telefone || "(não informado)"}
              </p>
            </div>
          </div>

          <Separator className="my-8 opacity-50" />

          {!isAdminMode && (
            <p className="text-xs font-medium text-slate-500 mb-8 bg-slate-50 py-3 rounded-lg border border-slate-100">
              Dúvidas? Entre em contato: <span className="text-slate-900 font-bold">(11) 93333-3012</span>
            </p>
          )}

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            {isAdminMode ? (
              <Button onClick={onReturnToAdmin} variant="outline" className="h-11 px-8 border-cessaoYellow text-cessaoYellow hover:bg-cessaoYellow/5 font-bold">
                Página Inicial
              </Button>
            ) : (
              <Button onClick={onExit} className="h-11 px-8 bg-slate-900 text-white hover:bg-slate-800 font-bold">
                Sair do Sistema
              </Button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ConfirmationView;
